<template>
  <div class="space-y-4">
    <!-- Loading State -->
    <LoadingIndicator v-if="loading" message="Loading thread details..." />

    <!-- Empty State -->
    <div v-else-if="subthreads.length === 0" class="py-12 text-center bg-gray-50 rounded-lg border border-gray-200">
      <font-awesome-icon :icon="['fas', 'comments']" class="text-4xl text-gray-400 mb-4" />
      <p class="text-sm text-gray-600">No discussion threads found for this engagement</p>
    </div>

    <!-- Subthreads List -->
    <transition-group
      v-else
      name="list"
      tag="div"
      class="space-y-4"
    >
      <Details_Subthread
        v-for="thread in subthreads"
        :key="thread.object_id"
        :subthread="thread"
      />
    </transition-group>
  </div>
</template>

<script>
import axios from "axios";
import Details_Subthread from "@/components/Details/Details_Subthread.vue";
import LoadingIndicator from "@/components/widgetcomponents/library/LoadingIndicator.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Font Awesome imports
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faComments
} from '@fortawesome/free-solid-svg-icons'

// Add icons to library
library.add(
  faComments
)

export default {
  components: {
    Details_Subthread,
    FontAwesomeIcon,
    LoadingIndicator
  },
  props: {
    object: {
      type: Object,
      default: () => ({})
    },
    engagement_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      subthreads: [],
      loading: true
    }
  },
  methods: {
    async fetchSubthreads() {
      this.loading = true;

      try {
        const response = await axios.get('/api/subthreads/', {
          params: {
            engagement_id: this.engagement_id,
          },
        });

        if (response.data?.length > 0) {
          this.subthreads = response.data;
        } else {
          this.subthreads = [];
        }
      } catch (error) {
        console.error('Error fetching subthreads:', error);
        this.subthreads = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchSubthreads();
  }
}
</script>

<style scoped>
/* List transitions */
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.list-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.list-move {
  transition: transform 0.3s ease;
}

</style>
